(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mkp-help-choose"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-mkp-help-choose]');
    if (!link) return;
    const form = document.getElementById(link.dataset.productForm);
    const variant = form?.elements.namedItem('id')?.value;
    const destination = new URL(link.href);
    const productPath = destination.searchParams.get('product');
    if (!productPath) return;
    const productUrl = new URL(productPath, location.origin);
    if (variant) productUrl.searchParams.set('variant', variant);
    destination.searchParams.set('product', productUrl.pathname + productUrl.search);
    link.href = destination.href;
  });
  } catch(e) { console.error(e); }
})();

})();
